import { render, staticRenderFns } from "./Restapi.vue?vue&type=template&id=40118fb8&scoped=true"
import script from "./Restapi.vue?vue&type=script&lang=js"
export * from "./Restapi.vue?vue&type=script&lang=js"
import style0 from "./Restapi.vue?vue&type=style&index=0&id=40118fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40118fb8",
  null
  
)

export default component.exports